import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for PWA on web only (skip in Capacitor native)
const isNative = typeof window !== 'undefined' && window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform() !== 'web';
if ('serviceWorker' in navigator && !isNative) {
  window.addEventListener('load', () => {
    const swUrl = `/service-worker.js`;
    // updateViaCache:'none' => the browser never serves the SW script (or its imports) from the
    // HTTP cache, so a new deploy's service worker is always detected.
    navigator.serviceWorker.register(swUrl, { scope: '/', updateViaCache: 'none' })
      .then((registration) => {
        console.log('Service Worker registered:', registration);
        // Force update check
        registration.update();

        // Re-check for a new deploy when the tab regains focus and periodically, so a long-open
        // tab updates itself instead of the user having to hard-refresh (Shift+F5).
        const checkForUpdate = () => { try { registration.update(); } catch (_) {} };
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
        window.addEventListener('focus', checkForUpdate);
        setInterval(checkForUpdate, 60 * 1000);

        // When a new SW takes control, reload once so we pick up the newest /static/ bundles.
        let reloading = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloading) return;
          reloading = true;
          window.location.reload();
        });
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

